export default __webpack_public_path__ + "static/media/neopreno-mujer.f0e53dc2.png";